"use strict";

var _interopRequireDefault = require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _request = _interopRequireDefault(require("@/utils/request"));

var _main = _interopRequireDefault(require("./src/main"));

var install = function install(Vue) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  Vue.component('ElSearchTablePagination', _main.default);
  Vue.prototype.$axios = _request.default;
};

if (window.Vue) {
  window['ElSearchTablePagination'] = _main.default;
  Vue.use(install); // eslint-disable-line
}

_main.default.install = install;
var _default = _main.default;
exports.default = _default;